import React, { useState} from 'react';

import SyntaxHighlighter from 'react-syntax-highlighter';
import { darcula } from 'react-syntax-highlighter/dist/esm/styles/hljs';
import {CopyToClipboard} from 'react-copy-to-clipboard';
import PropTypes from "prop-types";
import {Button, Paper, Tooltip} from "@material-ui/core";
import Box from "@material-ui/core/Box";
import BBIconCopyClipboard from "../../../assets/bbCustomIcons/BBIconCopyClipboard";
import BBIconCheck from "../../../assets/bbCustomIcons/BBIconCheck";
import  { saveAs } from 'file-saver';
import BBIconDownloadScriptCode from "../../../assets/bbCustomIcons/BBIconDownloadScriptCode";
import BBIconExeExecuteCode from "../../../assets/bbCustomIcons/BBIconExeExecuteCode";


const BBCodeCopyContainer = (props) => {


    const {
        displayText,
        showDownload = false,
        fileName = null,
        language="powershell",
        fileType = "application/x-bat;charset=utf-8",
        //text data:text/plain;charset=utf-8
        titleDescriber = "Code",
        titleIcon = <BBIconExeExecuteCode/>,
        isNotExecutable = false,
    } = props;
    const [codeCopied, setCodeCopied] = useState(false);

    console.log("BBCodeCopyContainer", "displayText", displayText, "typeof displayText", typeof displayText, "language", language);

    const useThisCopyText = typeof displayText === 'string' ? displayText : "Unrecognized text provided. Please contact support@breachbits.com."

    if (typeof displayText !== 'string'){
        console.warn("BBCodeCopyContainer displayText is not a string", "displayText", displayText, "typeof displayText", typeof displayText);
    }

    const convertAndSaveAs = () => {
        try{
            const blob = new Blob([displayText], {type: fileType});
            saveAs(blob, fileName);
        } catch(e) {
            console.warn(e);
        }
    }

    return (
        <Paper className={"p-1 my-2"} elevation={5}>
            <Box display="flex" flexDirection="row" p={1} m={1}>
                <div>
                    <h3><pre>{titleIcon} {titleDescriber} Viewer</pre></h3>
                </div>
                <div style={{marginLeft: "auto", marginRight:4}}>

                    <CopyToClipboard text={useThisCopyText}
                                     onCopy={() => setCodeCopied(true)}>
                        <Tooltip title={`Copy ${titleDescriber} to clipboard`}>
                            <Button
                                variant="outlined"
                                color="default"
                                size={"small"}
                            >
                                {codeCopied
                                    ? <><BBIconCheck className="text-electric-blue" style={{marginRight:4, }}/> Copied!</>
                                    : <BBIconCopyClipboard/>}
                            </Button>
                        </Tooltip>

                    </CopyToClipboard>
                </div>
                {showDownload &&
                <div style={{marginLeft: 4, marginRight:4}}>

                    <Tooltip title={isNotExecutable ? "Save as file" : "Save as executable script"}>
                        <Button
                            variant="outlined"
                            color="default"
                            onClick={convertAndSaveAs}
                            size={"small"}
                        >
                            <BBIconDownloadScriptCode/>
                        </Button>
                    </Tooltip>

                </div>
                }

            </Box>

            <div>
                <SyntaxHighlighter
                    language={language}
                    style={darcula}
                    showLineNumbers
                    wrapLongLines
                    wrapLines
                    customStyle={{borderRadius: "3px"}}
                >
                    {useThisCopyText}
                </SyntaxHighlighter>
            </div>



        </Paper>
    )

}

BBCodeCopyContainer.propTypes = {
    displayText: PropTypes.string.isRequired,
    showDownload: PropTypes.bool,
    fileName: PropTypes.string,
    fileType: PropTypes.string,
    titleIcon: PropTypes.element,
}

export default BBCodeCopyContainer;